import type { SourceItem } from "@/services/aiService";

interface Props {
  sources: SourceItem[];
  onExpand: () => void;
}

export default function ChatSourceBadge({ sources, onExpand }: Props) {
  const filtered = sources.filter((s) => {
    try {
      return new URL(s.url).hostname.replace("www.", "") === "my.evvy.com";
    } catch {
      return false;
    }
  });

  if (filtered.length === 0) return null;

  let firstName: string;
  try {
    firstName = new URL(filtered[0].url).hostname.replace("www.", "");
  } catch {
    firstName = filtered[0].url;
  }
  const extraCount = filtered.length - 1;

  return (
    <button
      onClick={onExpand}
      className="flex items-center gap-[var(--chat-space-02)] bg-[var(--chat-creme)] rounded-[var(--chat-corner-base)] px-[var(--chat-space-03)] py-[var(--chat-space-01)] text-[var(--chat-text-xs)] text-[var(--chat-grey-500)] leading-[1.5] hover:opacity-70 transition-opacity"
    >
      <span className="truncate max-w-[150px]">{firstName}</span>
      {extraCount > 0 && <span>+{extraCount}</span>}
    </button>
  );
}
